import React from "react";
import { NavLink } from "react-router-dom";
import PrivateNavLink from "./components/Private/PrivateNavLink";
import config from "./config";

/**
 * Add your list of links here
 *
 * @type {*[]}
 */
export default [
  <NavLink to="/">Home</NavLink>,
  <PrivateNavLink to="/users" permissions={config.oauth.scope}>
    Users
  </PrivateNavLink>,
  <PrivateNavLink to="/roles" permissions={config.oauth.scope}>
    Roles
  </PrivateNavLink>,
  <PrivateNavLink to="/permissions" permissions={config.oauth.scope}>
    Permissions
  </PrivateNavLink>
];



// WEBPACK FOOTER //
// ./src/navLinks.js